// extracted by mini-css-extract-plugin
export default {"splitter":"src-views-common-components-SubtitlesPreview-components-SubtitlesBody-SubtitlesBody__splitter--F7N4U"};